import React, {memo} from 'react';
import {AdminForm} from '../../Component/Form/AdminForm';
import {AdminCrudPage} from '../../Component/Page/AdminCrudPage';

export const CategoryAdminAddScreen: React.FC = memo(() => (
  <AdminCrudPage entityType="category" action="Add">
    <AdminForm redirectUrl="/admin/category" mutationName="addCategory"/>
  </AdminCrudPage>
));
